import actions from './utils/actions.js'
import { processFormData } from './utils/general.js'

document.addEventListener('DOMContentLoaded', () => {
  var form = document.getElementById('candidates-form')
  if (form) {
    form.onsubmit = (ev) => {
      ev.preventDefault()
      var button = document.getElementById('candidates-button')
      button.setAttribute("disabled","disabled");
      button.setAttribute("value","ENVIANDO...");
      const inputs = ev.target.elements
      const data = processFormData(inputs)
      actions.createCandidate(data, (err, res) => {
        if (err) { return window.alert('Lo sentimos, algo salió mal') }
        window.alert('Tu registro ha finalizado con éxito')
        window.location.reload(true)
      })
    }
  }
})
